const initials = (firstName, lastName) => {
  const fName = firstName || ''
  const lName = lastName || ''
  return `${fName.substring(0, 1)}${lName.substring(0, 1)}`
}

export default initials
